(function () {
  'use strict';

  if (window.storeNearestReady) return;
  window.storeNearestReady = true;

  const storageKey = 'store-nearest-position';

  const readPosition = () => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey));
    } catch (error) {
      return null;
    }
  };

  const savePosition = (position) => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(position));
    } catch (error) {}
  };

  const toRadians = (degrees) => (degrees * Math.PI) / 180;

  const distanceInKm = (from, to) => {
    const deltaLat = toRadians(to.lat - from.lat);
    const deltaLng = toRadians(to.lng - from.lng);
    const a = Math.sin(deltaLat / 2) ** 2 + Math.cos(toRadians(from.lat)) * Math.cos(toRadians(to.lat)) * Math.sin(deltaLng / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const sortStores = (position) => {
    const list = document.querySelector('[data-store-availability-list]');
    if (!list || !position) return;

    const items = Array.from(list.querySelectorAll('[data-store-location]'));
    items.forEach((item) => {
      const lat = parseFloat(item.dataset.lat);
      const lng = parseFloat(item.dataset.lng);
      item.storeDistance = Number.isNaN(lat) || Number.isNaN(lng) ? Infinity : distanceInKm(position, {lat, lng});

      const label = item.querySelector('[data-store-distance]');
      if (label && item.storeDistance !== Infinity) {
        label.textContent = `${Math.round(item.storeDistance)} ${list.dataset.unit}`;
      }
    });

    items
      .sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true') || a.storeDistance - b.storeDistance)
      .forEach((item) => list.appendChild(item));

    const button = document.querySelector('[data-store-nearest]');
    if (button) button.hidden = true;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-store-nearest]');

    if (button) {
      const status = button.parentElement.querySelector('[data-store-nearest-status]');
      const showError = () => {
        button.disabled = false;
        if (status) status.textContent = button.dataset.error;
      };

      if (!navigator.geolocation) {
        showError();
        return;
      }

      button.disabled = true;
      navigator.geolocation.getCurrentPosition(
        (result) => {
          const position = {lat: result.coords.latitude, lng: result.coords.longitude};
          savePosition(position);
          if (status) status.textContent = '';
          sortStores(position);
        },
        showError,
        {maximumAge: 600000, timeout: 10000}
      );
      return;
    }

    if (event.target.closest('[data-store-availability-modal-open]')) {
      sortStores(readPosition());
    }
  });
})();
